<template>
  <div class="content-container">
    <div
      class="background-container"
      :class="showCastle === true ? 'hogwarts' : 'smoke'"
    ></div>

    <div key="load" class="content loading" v-if="loading">
      <h1>Loading...</h1>
    </div>

    <div
      key="content"
      class="content"
      v-else
      :class="[{ vertical }, contentClass]"
    >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
@import "../styles/colours.scss";
@import "../styles/fontstyles.scss";

.content-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em;
  background-image: $background-gradient;

  font-family: "Linotype", serif;
  color: $text-color;
  margin: 0;
  height: 100%;

  background-color: $black-pearl;

  .background-container {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &.hogwarts {
      background-image: url("../assets/bg-with-castle.png");
    }

    &.smoke {
      background-image: url("../assets/bg-without-castle.png");
    }
  }

  .content {
    width: 100%;
    height: 100%;
    border: 1px solid white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 100;
    padding: 1em;
    &.vertical {
      flex-direction: row;
    }
  }
}
</style>

<script>
export default {
  props: ["showCastle", "vertical", "contentClass", "loading"],
};
</script>